var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "382px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 17.69 23.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA0000",
    d: "M3.08 0l7.91 0 6.7 6.99 0 13.58c0,1.7 -1.38,3.08 -3.08,3.08l-11.53 0c-1.7,0 -3.08,-1.38 -3.08,-3.08l0 -17.49c0,-1.7 1.38,-3.08 3.08,-3.08z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    fillOpacity: 0.301961,
    points: "10.98,0 10.98,6.93 17.69,6.93 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M12.94 12.66c-0.08,-0.06 -0.2,-0.06 -0.29,-0.02l-1.99 1 0 -0.72c0,-0.51 -0.4,-0.91 -0.91,-0.91l-4.24 0c-0.5,0 -0.91,0.4 -0.91,0.91l0 3.63c0,0.51 0.41,0.91 0.91,0.91l4.24 0c0.51,0 0.91,-0.4 0.91,-0.91l0 -0.72 1.99 1c0.15,0.07 0.33,0.01 0.41,-0.14 0.02,-0.04 0.03,-0.09 0.03,-0.14l0 -3.63c0,-0.11 -0.06,-0.21 -0.15,-0.26zm-5.31 3.29c-0.67,0 -1.21,-0.55 -1.21,-1.22 0,-0.67 0.54,-1.21 1.21,-1.21 0.67,0 1.21,0.54 1.21,1.21 0,0.67 -0.54,1.22 -1.21,1.22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.d41177112d216a7385da1d2b066174fc.svg";
export { ForwardRef as ReactComponent };